import { useStrings } from "@1js/localization-components";
import type { PromptCategory } from "@1js/pl-types";
import type { ProductType } from "../data";
import {
  AdminLabel,
  AskCategoryLabel,
  BadgesGroupLabel,
  BusinessLeaderLabel,
  CatchUpCategoryLabel,
  CopilotForMicrosoft365Label,
  CreateCategoryLabel,
  CustomizeCategoryLabel,
  DepartmentLabel,
  DesignCategoryLabel,
  EditCategoryLabel,
  ExcelLabel,
  FinancialServicesLabel,
  FormsLabel,
  HomeUserLabel,
  HumanResourcesLabel,
  IndustryLabel,
  ManufacturingLabel,
  MarketingLabel,
  OneDriveLabel,
  OneNoteLabel,
  OperateCategoryLabel,
  OptimizeCategoryLabel,
  OutlookLabel,
  PlannerLabel,
  PowerPointLabel,
  RetailLabel,
  SharePointLabel,
  StreamLabel,
  SummarizeCategoryLabel,
  TeamsLabel,
  TroubleshootCategoryLabel,
  UnderstandCategoryLabel,
  VivaEngageLabel,
  VivaGoalsLabel,
  WindowsLabel,
  WordLabel,
} from "../sharedStrings";
import {
  AppFilterLabel,
  DisplayFilterLabel,
  JobTypeFilterLabel,
} from "./PromptFilter.strings";

export const usePromptFilterLocalizations = () => {
  const localizations = useStrings({
    AppFilterLabel,
    DisplayFilterLabel,
    OneDriveLabel,
    OneNoteLabel,
    OutlookLabel,
    ExcelLabel,
    WordLabel,
    PowerPointLabel,
    CopilotForMicrosoft365Label,
    BadgesGroupLabel,
    TeamsLabel,
    CatchUpCategoryLabel,
    CreateCategoryLabel,
    AskCategoryLabel,
    EditCategoryLabel,
    UnderstandCategoryLabel,
    SummarizeCategoryLabel,
    CustomizeCategoryLabel,
    HomeUserLabel,
    BusinessLeaderLabel,
    AdminLabel,
    SharePointLabel,
    WindowsLabel,
    FormsLabel,
    PlannerLabel,
    StreamLabel,
    VivaEngageLabel,
    VivaGoalsLabel,
    JobTypeFilterLabel,
    DesignCategoryLabel,
    OptimizeCategoryLabel,
    TroubleshootCategoryLabel,
    OperateCategoryLabel,
    DepartmentLabel,
    IndustryLabel,
    HumanResourcesLabel,
    MarketingLabel,
    FinancialServicesLabel,
    RetailLabel,
    ManufacturingLabel,
  });

  const facetKeyToLabel = (facetKey: string): string => {
    switch (facetKey.toLowerCase()) {
      case "displaycategory":
        return localizations.DisplayFilterLabel();
      case "products/name":
        return localizations.AppFilterLabel();
      case "jobtype":
        return localizations.JobTypeFilterLabel();
      default:
        return facetKey;
    }
  };

  const facetValueToLabel = (
    facetValue: ProductType | PromptCategory | string
  ): string => {
    switch (facetValue) {
      case "Word":
        return localizations.WordLabel();
      case "PowerPoint":
        return localizations.PowerPointLabel();
      case "Outlook":
        return localizations.OutlookLabel();
      case "Teams":
        return localizations.TeamsLabel();
      case "BizChat":
        return localizations.CopilotForMicrosoft365Label();
      case "Copilot":
        return localizations.CopilotForMicrosoft365Label();
      case "OneDrive":
        return localizations.OneDriveLabel();
      case "OneNote":
        return localizations.OneNoteLabel();
      case "Excel":
        return localizations.ExcelLabel();
      case "Windows":
        return localizations.WindowsLabel();
      case "SharePoint":
        return localizations.SharePointLabel();
      case "Forms":
        return localizations.FormsLabel();
      case "Catch up":
        return localizations.CatchUpCategoryLabel();
      case "Create":
        return localizations.CreateCategoryLabel();
      case "Ask":
        return localizations.AskCategoryLabel();
      case "Edit":
        return localizations.EditCategoryLabel();
      case "Understand":
        return localizations.UnderstandCategoryLabel();
      case "Summarize":
        return localizations.SummarizeCategoryLabel();
      case "Customize":
        return localizations.CustomizeCategoryLabel();
      case "HomeUser":
        return localizations.HomeUserLabel();
      case "BusinessLeader":
        return localizations.BusinessLeaderLabel();
      case "Admin":
        return localizations.AdminLabel();
      case "Planner":
        return localizations.PlannerLabel();
      case "Stream":
        return localizations.StreamLabel();
      case "VivaEngage":
        return localizations.VivaEngageLabel();
      case "VivaGoals":
        return localizations.VivaGoalsLabel();
      case "Design":
        return localizations.DesignCategoryLabel();
      case "Optimize":
        return localizations.OptimizeCategoryLabel();
      case "Troubleshoot":
        return localizations.TroubleshootCategoryLabel();
      case "Operate":
        return localizations.OperateCategoryLabel();
      case "Human Resources":
        return localizations.HumanResourcesLabel();
      case "Marketing":
        return localizations.MarketingLabel();
      case "Financial Services":
        return localizations.FinancialServicesLabel();
      case "Retail":
        return localizations.RetailLabel();
      case "Manufacturing":
        return localizations.ManufacturingLabel();
      default:
        return facetValue;
    }
  };

  const groupValueToLabel = (groupValue: string): string => {
    switch (groupValue) {
      case "Department":
        return localizations.DepartmentLabel();
      case "Industry":
        return localizations.IndustryLabel();
      default:
        return groupValue;
    }
  };

  return { facetKeyToLabel, facetValueToLabel, groupValueToLabel };
};
